export * from './MenuMoreInfoRestaurantPhoneNumber';
